export default {
  smart: "REPAIR_TYPE_SMART",
  professional: "REPAIR_TYPE_PROFESSIONAL",
  leasing: "REPAIR_TYPE_LEASING"
};
